import FileViewerProvider from './FileViewerProvider'

const ANGULARJS_SIDE_NAV_ID = 'sidebar-wrapper'
const ANGULARJS_PAGE_CONTENT_ID = 'page-content-wrapper'

/**
 * Helper to show/hide the AngularJS side nav.
 */
function setSideNavState({ open }) {
  const { matches: hasSideNav } = window.matchMedia('(min-width: 992px)')
  if (!hasSideNav) {
    // When the sidenav isn't going to be shown (based on screen width in
    // AngularJS css) we know that the file viewer will also not be shown.
    // Therefore we don't want to change the sidenav state.
    return
  }

  const sideNavEl = document.getElementById(ANGULARJS_SIDE_NAV_ID)
  if (sideNavEl) {
    sideNavEl.style.display = open ? 'block' : 'none'
  }

  const pageContentWrapperEl = document.getElementById(
    ANGULARJS_PAGE_CONTENT_ID
  )
  if (pageContentWrapperEl) {
    pageContentWrapperEl.style.marginLeft = open ? '240px' : '0px'
  }
}

/**
 * A provider that wraps the `FileViewerProvider` and manages showing/hiding
 * the AngularJS side nav when the file viewer is undocked.
 */
export const SideNavAwareFileViewerProvider = ({
  children,
}: React.PropsWithChildren) => {
  return (
    <FileViewerProvider
      onUndock={() => {
        setSideNavState({ open: true })
      }}
      onDock={() => {
        setSideNavState({ open: false })
      }}
      onClose={() => {
        setSideNavState({ open: true })
      }}
    >
      {children}
    </FileViewerProvider>
  )
}
